/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_EyebrowInputs */

const en_pc_alt_eyebrow = /** @type {(inputs: Pc_Alt_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated October 2026`)
};

const zh_pc_alt_eyebrow = /** @type {(inputs: Pc_Alt_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2026 年 10 月更新`)
};

/**
* | output |
* | --- |
* | "Updated October 2026" |
*
* @param {Pc_Alt_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_eyebrow = /** @type {((inputs?: Pc_Alt_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_eyebrow(inputs)
	return zh_pc_alt_eyebrow(inputs)
});
export { pc_alt_eyebrow as "pc.alt.eyebrow" }